import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { config } from '../config';

const OKTA_REDIRECT_PATH = `${config.applicationPath}/login/callback`;

const oktaConfig: OktaAuthOptions = {
  issuer: config.oktaIssuer as string,
  clientId: config.oktaClientId,
  redirectUri: `${window.location.origin}${OKTA_REDIRECT_PATH}`,
  postLogoutRedirectUri: `${window.location.origin}${config.applicationPath}`,
  scopes: ['openid', 'email'],
  tokenManager: {
    storageKey: `okta-token-storage-${config.appName}`,
    autoRenew: true,
  },
};

export const oktaAuth = new OktaAuth(oktaConfig);
